/**
 * Convert allowlisted system backup values to Create Backup form state.
 *
 * System Backup's Create form has only a Backup Name field - no site, no
 * description - matching the field catalogue, which declares no other
 * prefillable surface for this resource.
 *
 * @param {object} values canonical agent values
 * @return {object} form patch
 */
export function mapSystemBackupPrefill(values = {}) {
	const patch = {};
	if (typeof values.backup_name === 'string' && values.backup_name.trim()) {
		patch.backupName = values.backup_name.trim();
	}
	return patch;
}
